module.exports = __webpack_public_path__ + "img/Unidad4-1.1a87ed8f.png";